module.exports = __webpack_public_path__ + "assets/img/HealthcareSolutions-aided-active.d65346ed.png";